import { useState } from 'react';
import ProductCard from './ProductCard';
import QuickViewModal from './QuickViewModal';

export default function ProductGrid({ products }) {
  const [qv, setQv] = useState(null);
  if (!products || products.length === 0) {
    return <p className="text-essenya-text py-10 text-center">Nessun prodotto trovato.</p>;
  }
  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-testid="product-grid">
        {products.map(p => <ProductCard key={p.id} product={p} onQuickView={setQv} />)}
      </div>
      <QuickViewModal product={qv} onClose={() => setQv(null)} />
    </>
  );
}
